import { PaymentCenterComponent } from "@/features/client"
import { Deal } from "@/types"
import { useOutletContext } from "react-router-dom"

type ClientOutletContext = {
  deals: Deal[]
  isLoading: boolean
}

export const PaymentCenterPage = () => {
  const { deals, isLoading } = useOutletContext<ClientOutletContext>()

  return <PaymentCenterComponent deals={deals} isLoading={isLoading} />
}
